import { ENVIRONMENT } from "../environment";

const API = {
    anon_list_config: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/configuration/anon-list-configs/`,
    list_config: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/configuration/list-configs/`,
    web_list_config: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/configuration/list-web-configs/`,
    serverTime: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/configuration/server-time/`,
    feedbackLog: () => `${ENVIRONMENT.uploadCenter}`,
    auth: {
        login: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/login/`,
        logout: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/logout/`,
        code: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/generate-code/`,
        validateCode: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/validate-otp/`,
        refresh: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/token-refresh/`,
        profile: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/get-profile/`,
        userSessions: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/profile/list-active-tokens/`,
        deleteSessions: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/profile/delete-tokens/`,
        changeProfile: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/set-profile/`,
        createProfileUrl: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/create-profile-url/`,
        captcha: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/captcha/get-captcha/`,
        password: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/change-password/`,
        policy: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/configuration/get-password-policies/fa/`,
        changePhone: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/change-phone/`,
        deleteAccount: (v = "v5") => `${ENVIRONMENT.baseUrl()}/${v}/profile/auth/delete-account/`
    },
    fileManager: {
        list: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/list-objects/`,
        getObject: (id: number | undefined, v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/get-object/${id}/`,
        createFolder: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/create-folder/`,
        quota: (v = "v5") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/get-quota/`,
        copy: (v = "v5") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/copy-object/`,
        zipObjects: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/zip-objects/`,
        rename: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/rename-object/`,
        trash: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/trash-objects/`,
        delete: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/delete-verion-groups/`,
        deleteSingleVersion: (id: number, v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/delete-object/${id}/`,
        restore: (v = "v5") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/restore-object/`,
        addFavorite: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/favorite/create-favorite/`,
        deleteFavorite: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/favorite/delete-favorite/`,
        move: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/move-object/`,
        createPublicLink: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/sharing/public-link/create/`,
        editPublicLink: (id: number | undefined, v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/sharing/public-link/edit/${id}/`,
        deletePublicLink: (id: number | undefined, v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/sharing/public-link/delete/${id}/`,
        search: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-objects/`,
        searchShare: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-shared-objects/`,
        suggest: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/suggest-objects/`,
        duplicatedObjects: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/flat/list-duplicated-objects/`,
        versionHistory: (versionGroup: string, v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/get-version-history/?version_group=${versionGroup}`,
        keep: (id: number, v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/flat/keep-forever/${id}/`,
        unKeep: (id: number, v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/flat/unkeep-forever/${id}/`,
        checkExcelStatus: (versionGroup: string, v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/check-editing-object/${versionGroup}/`
    },
    plan: {
        buy: (v = "v4") => `${ENVIRONMENT.baseUrl()}/${v}/plan/buy-plan/`,
        getPlan: (v = "v4", plan_id: string) => `${ENVIRONMENT.baseUrl()}/${v}/plan/get-plan/${plan_id}/`,
        list: (v = "v4") => `${ENVIRONMENT.baseUrl()}/${v}/plan/list-plans/`,
        purchases: (v = "v4") => `${ENVIRONMENT.baseUrl()}/${v}/plan/list-purchases/`,
        deactivatePurchase: (v = "v1", plan_id: string) => `${ENVIRONMENT.baseUrl()}/${v}/plan/deactivate-purchase/${plan_id}/`,
        validateVoucher: (v = "v4") => `${ENVIRONMENT.baseUrl()}/${v}/plan/validate-plan-voucher/`,
        activeVoucher: (v = "v4") => `${ENVIRONMENT.baseUrl()}/${v}/plan/activate-plan-voucher/`,
        activeUserGifts: (v = "v5") => `${ENVIRONMENT.baseUrl()}/${v}/rgw/active-user-gifts/`
    },
    storage: {
        list: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/storage/list-url-adds/`,
        update: (v = "v2", id: string) => `${ENVIRONMENT.baseUrl()}/${v}/storage/update-url-storage/${id}/`,
        check: (v = "v2", id: number) => `${ENVIRONMENT.baseUrl()}/${v}/storage/url-add-check/${id}/`,
        add: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/storage/url-add/`,
        deleteUploadLink: (id: number, v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/storage/delete-url-storage/${id}/`
    },
    share: {
        list: (v = "v4") => `${ENVIRONMENT.baseUrl()}/${v}/sharing/list-shared-objects/`,
        getObject: (v = "v4", obj_hash: string) => `${ENVIRONMENT.baseUrl()}/${v}/sharing/get-shared-object/${obj_hash}/`,
        setPermission: (v = "v2", id: number) => `${ENVIRONMENT.baseUrl()}/${v}/sharing/set-permission/${id}/`,
        unshare: (v = "v2", id: number) => `${ENVIRONMENT.baseUrl()}/${v}/sharing/unshare-object/${id}/`
    },
    upload: {
        start: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/start-upload/`,
        complete: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/complete-upload/`,
        abort: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/abort-upload/`
    },
    contact: {
        delete: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/contact/delete-contact/`,
        list: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/contact/list-contact/`,
        sync: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/contact/sync-contact/`,
        create: (v = "v6") => `${ENVIRONMENT.baseUrl()}/${v}/profile/contact/create-contact/`,
        getContact: (v = "v6", id: number) => `${ENVIRONMENT.baseUrl()}/${v}/profile/contact/get-contact/${id}/`,
        deleteAll: (v = "v5") => `${ENVIRONMENT.baseUrl()}/${v}/profile/contact/delete-all-contacts/`
    },
    landing: {
        download: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/versioning/download-links/`
    },
    reporting: {
        createHistorySearch: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-history/create/`,
        getHistorySearch: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-history/list/`,
        deleteHistorySearch: (v = "v3", id: number | string) => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-history/delete/${id}/`,
        deleteAllHistorySearch: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-history/delete/`,
        search: (v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-objects/`,
        sharedSearch: (v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/reporting/search-shared-objects/`,
        histogram: "v1/drive-reporting/histogram/",
        top: "v1/drive-reporting/top/"
    },
    notification: {
        list: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/notification/list-notifications/`,
        read: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/notification/read-notifications/`,
        unread: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/notification/unread-notifications/`,
        remove: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/notification/delete-notifications/`
    },
    organization: {
        listUser: (orgId: number, v = "v3") => `${ENVIRONMENT.baseUrl()}/${v}/organization/list-user/${orgId}/`
    },
    ewanoWallet: {
        balance: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/wallet/ewano/balance/`,
        contract: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/wallet/ewano/get-contract/`,
        reserve: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/wallet/ewano/reserve/`,
        increase_balance: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/wallet/ewano/increase-balance/`,
        buy_plan: (v = "v1") => `${ENVIRONMENT.baseUrl()}/${v}/wallet/ewano/buy-plan/`
    },
    newVoucher: {
        validate: (v = "v4") => `${ENVIRONMENT.baseUrl()}/${v}/plan/new-voucher/validate/`
    },
    collabora: (versionGroup: string, v = "v2") => `${ENVIRONMENT.baseUrl()}/${v}/flat/wopi/get-wopi-url/${versionGroup}/`
};

export default API;
